import Spinner from "../assets/Spinner.gif";

const LoadingCover = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={Spinner} />
    </div>
  );
};

export default LoadingCover;
